import React, { useEffect, useState, useRef } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";
import CategoryImg from "../../assets/images/default_service_img.png";
import FreeProvider from "../../assets/images/new-logo2.png";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import "swiper/css";
import "./categoryDetails.scss";
import { Button, Col, Dropdown, Row, Form } from "react-bootstrap";
import {
  DownArrow,
  FilterIcon,
  LocationIcon,
} from "../../components/Icons";
import Paginate from "../../components/paginate/Paginate";

import { useLocation, useNavigate } from "react-router-dom";
import {
  childrenServiceList,
  filterProvider,
  getCategoriesList,
  getProviderListByServiceId,
  serviceFilter,
  serviceList,
} from "../../services/auth.service";
import {  getFullName } from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { setLoader, setUserId, userLocation } from "../../slice/commonSlice";
import { max, min, ratings, sortBy } from "../../config/Constant";
import { RangeSlider } from "rsuite";
import { selectFilterdata, selectFilterdataModal } from "../../slice/filterSlice";
// import "rsuite/dist/rsuite.css";
import StarRating from "../../components/rating/StarRating";
import NoRecords from "../../components/noRecords/NoRecords";
import NoRecordsProvider from "../../components/noProvider/noProvider";
import NoDogs from "../../assets/images/nodogs.jpg";
import Allergy from "../../assets/images/allergy.png";
import Disability from "../../assets/images/disability.png";
import { filterData, filterDataModal, clearFilterData, clearFilterDataModal } from "../../slice/filterSlice";
const CategoryDetails = () => {
  const [activeTab, setActiveTab] = useState("");
  const [catergoryNavOpen, setCatergoryNavOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const listRef = useRef(null);
  const dispatch = useDispatch();
  const userLoc = useSelector(userLocation);
  const filterdatamodal = useSelector(selectFilterdataModal);
  const filterdata = useSelector(selectFilterdata);
  const [service, setService] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [showSubCategory, setShowSubCategory] = useState(false);
  const [selectCategory, setSelectCategory] = useState("");
  const [selectService, setSelectService] = useState("");
  const [selectRating, setSelectRating] = useState("");
  const [selectSortBy, setSelectSortBy] = useState("");
  const [selectPageNumber, setSelectPageNumber] = useState("");
  const [rangeValues, setRangeValues] = useState([min, max]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterA, setFilterA] = useState(false);
  const [page, setPage] = useState(1);
  const [label, setLabel] = useState();
  //payload data from landing page
  const location = useLocation();
  const navigate = useNavigate();
  //state for storing provider data
  const [providerData, setProviderData] = useState([]);

  const getBadgeInfo = (item) => {
    switch (item) {
      case "Sunflower":
        return "Sunflower";
      case "Allergies":
        return "Allergies";
      case "SCARS":
        return "SCARS";
      case "Police Background":
        return "Police Background";
      case "Disability":
        return "Disability";
      case "No Dogs":
        return "No Dogs";
      default:
        return null;
    }
  }

  const avatarSources = {
    "No Dogs": NoDogs,
    "Allergies": Allergy,
    "SCARS": Disability,
    "Police Background": Disability,
    "Sunflower": Disability,
    "Disability": Disability,
  };

  const handleTabClick = async (service) => {
    // const dispatch = useDispatch();
    // setTotalPages(0);
    // setCurrentPage(1);
    console.log("inside handletabclick")
    setFilterA(false)
    setCurrentPage(1);
    const payload = {
      search: service?.name,
      pageNumber: 1,// Added pageNumber to the payload
      lat: userLoc.lat,
      lng: userLoc.long,
    };

    await dispatch(filterData(payload));
    console.log("service?.name", service?.name)
    setActiveTab(service?.name);

    fetchProvider(service?._id);
    if (catergoryNavOpen) {
      setCatergoryNavOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setCatergoryNavOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

 
  const getProvidrData = async (page) => {
    await dispatch(clearFilterDataModal())
    setFilterA(false);
    let updatedObject = Object.assign({}, filterdata, {
      pageNumber: page || 1,
    });
    await dispatch(setLoader(true));
    if (filterdata?.search) {
      const payload = updatedObject;
      const response = await filterProvider(payload);
      await dispatch(setLoader(false));
      setProviderData(response?.data?.providerData);
      setCurrentPage(page);
      setTotalPages(response?.data?.totalPages);
    } else {
      const payload = updatedObject;
      setCurrentPage(page);
      const response = await serviceFilter(payload);
      await dispatch(setLoader(false));
      setProviderData(response?.data?.providerData);
      setTotalPages(response?.data?.totalPages);
    }
    await dispatch(setLoader(false));
  };

  const filterData1 = async (service) => {
    await dispatch(clearFilterData())
    setFilterA(true);
    const filter = {
      category: selectCategory,
      subCategory: selectService,
      rating: selectRating,
      price: {
        min: rangeValues[0],
        max: rangeValues[1],
      },
    };

    const payload = {
      lat: userLoc?.lat,
      lng: userLoc?.long,
      filter: filter,
      sortBy: selectSortBy,
      pageNumber: 1,
    };
    const payload1 = {
      lat: userLoc?.lat,
      lng: userLoc?.long,
      filter: filter,
      sortBy: selectSortBy,
      pageNumber: 1,
      label: label
    };
    await dispatch(filterDataModal(payload1))
    // await filterDataProvider(payload);
    await dispatch(setLoader(true));
    try {
      const response = await serviceFilter(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setProviderData(response?.data?.providerData);
        setTotalPages(response?.data?.totalPages);
        setCurrentPage(1);
        setActiveTab(label);
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
    clearFilter();
    setIsDropdownOpen(false);
  };

  const filterData2 = async (page) => {
    setActiveTab(filterdatamodal?.label);
    const filter = {
      category: filterdatamodal?.filter?.category,
      subCategory: filterdatamodal?.filter?.subCategory,
      rating: filterdatamodal?.filter?.rating,
      price: {
        min: filterdatamodal?.filter?.price?.min,
        max: filterdatamodal?.filter?.price?.max,
      },
    };
    const payload = {
      lat: filterdatamodal?.lat,
      lng: filterdatamodal?.lng,
      filter: filter,
      sortBy: filterdatamodal?.sortBy,
      pageNumber: page | 1,
    };
    await dispatch(filterDataModal(payload))
    console.log("payload inside filterdata2", payload)

    await filterDataProvider(payload);

    clearFilter();
    setIsDropdownOpen(false);
  };

  const filterDataProvider = async (payload) => {
    await dispatch(setLoader(true));
    try {
      const response = await serviceFilter(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        console.log("response?.data?.providerData", response?.data?.providerData)
        setProviderData(response?.data?.providerData);
        setTotalPages(response?.data?.totalPages);
        setCurrentPage(payload?.pageNumber);
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };

  // const  handlePagination = async () => {
  //   if(filterA == true){
  //     filterData1();
  //   }else{
  //     getProvidrData();
  //   }
  // }
  function sortByJobType(arr, jobType) {
    // Define a custom sorting function based on job type
    const customSort = (a, b) => {
      if (a.jobType === jobType && b.jobType !== jobType) {
        return -1; // a comes before b
      } else if (a.jobType !== jobType && b.jobType === jobType) {
        return 1; // b comes before a
      } else {
        return 0; // maintain the current order
      }
    };

    // Sort the array using the custom sorting function
    const sortedArray = arr.sort(customSort);

    return sortedArray;
  }
  // const fetchCategories = async () => {
  //   let payload = {
  //     "keyword": "",
  //     "isParent": false
  //   }
  //   await dispatch(setLoader(true));
  //   try {
  //     const response = await getCategoriesList(payload);
  //     await dispatch(setLoader(false));
  //     if (response.status) {

  //       if (response?.data?.services?.length > 0) {
  //         let services = response?.data?.services?.filter((item) => item.name !== 'Services');
  //         if (location?.state?.redType === 'search' || location?.state?.redType === 'search-filter') {
  //           setCategoriesList(services);
  //         }else{
  //           if(location?.state?.type){
  //             let sortedData = sortByJobType(services, location?.state?.type);
  //             setCategoriesList(sortedData);
  //             setActiveTab(sortedData[0]?.name);
  //             fetchProvider(sortedData[0]?._id);
  //           }else{
  //             setCategoriesList(services);
  //             setActiveTab(services[0]?.name);
  //             fetchProvider(services[0]?._id);
  //           }
  //         }

  //       }
  //     }
  //   } catch (error) {
  //     await dispatch(setLoader(false));
  //     console.error("Error fetching data:", error);
  //   }
  // }

  const fetchCategories = async () => {
    let payload = {
      keyword: "",
      isParent: false,
    };
    await dispatch(setLoader(true));
    try {
      const response = await getCategoriesList(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        if (response?.data?.services?.length > 0) {
          let services = response?.data?.services?.filter(
            (item) => item.name !== "Services"
          );
          if (
            filterdata?.redType === "search" ||
            filterdata?.redType === "search-filter"
          ) {
            setCategoriesList(services);
          } else {
            if (filterdata?.type) {
              let sortedData = sortByJobType(services, filterdata?.type);
              setCategoriesList(sortedData);
              // setActiveTab(sortedData[0]?.name);
              // fetchProvider(sortedData[0]?._id);
            } else {
              setCategoriesList(services);
              // setActiveTab(services[0]?.name);
              // fetchProvider(services[0]?._id);
            }
          }
        }
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };





  const fetchProvider = async (id) => {
    let payload = {
      serviceId: id,
      search: "",
      pageNumber: 1,
      // "lat": 23.0459112,
      // "lng": 72.5019611
      lat: userLoc?.lat,
      lng: userLoc?.long,
    };
    // await dispatch(filterData(payload))
    await dispatch(setLoader(true));
    try {
      const response = await getProviderListByServiceId(payload);
      console.log("provider", response?.data?.providerData)
      await dispatch(setLoader(false));
      if (response.status) {
        setProviderData(response?.data?.providerData);
        setTotalPages(response?.data?.totalPages)
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };
  const getService = async () => {
    const serviceRes = await serviceList("", true);

    let [service] = serviceRes?.data?.services?.filter(
      (item) => item?.jobType === "services"
    );
    let payload = {
      serviceId: service?._id,
    };
    const serviceResSub = await childrenServiceList(payload);
    setSubCategory(serviceResSub?.data?.services);
    setService(serviceRes?.data?.services);
  };

  useEffect(() => {
    getService();
    fetchCategories();
    if (filterdata != null) {
      console.log("inside search")
      setActiveTab(filterdata?.search);
      getProvidrData(1);
    } else {
      filterData2()
    }
  }, []);

  const toggleDropdown = () => {
    setCatergoryNavOpen(!catergoryNavOpen);
  };

  const getData = () => { };

  //function to navigate to view provider details
  const goToProviderProfile = async (provider) => {

    let payload = {
      id: provider?.userId?._id,
      serviceImages: provider?.images,
      serviceId: provider?.serviceId?._id,
      serviceName: provider?.serviceId?.name,
      jobType: provider?.serviceId?.jobType,
      unitPrice: provider?.rate,
    };
    navigate("/consumer/viewprofile", { state: payload });
  };

  const handleSliderChange = (values) => {
    setRangeValues(values);
  };

  const handleCategorryChange = async (id, jobType) => {
    setSelectCategory(id);
    setSelectService("");
    setShowSubCategory(false);
    if (jobType === "services") {
      setShowSubCategory(true);
    }
  };

  const handleSeviceChange = async (event) => {
    setSelectService(event.target.value);
    const selectedOption = event.target.selectedOptions[0].label;
    console.log("selectedOption", selectedOption)
    setLabel(selectedOption)
  };

  const handleRateChange = async (event) => {
    setSelectRating(event.target.value);
  };

  const handleSortBy = (event) => {
    setSelectSortBy(event.target.value);
  };
  const clearFilter = () => {
    setSelectCategory(" ");
    setSelectService(" ");
    setSelectRating(" ");
    setSelectSortBy(" ");
    setShowSubCategory(false);
  };

  const handleCategory = async (event) => {
    // console.log("handlecategorychange")
    let id = event.target.value;
    let [serviceType] = service?.filter((i) => i?._id == id);
    setSelectCategory(id);
    setShowSubCategory(false);
    setSelectService("");
    if (serviceType?.jobType === "services") {
      setShowSubCategory(true);
    }
    // clearFilter();
  };



  return (
    <>
      {console.log("active tab==>", activeTab)}
      <Header />



      <PageHeading title="Category Details" />
      <div className="main-container">
        <div className="container-wrap">
          <div className="category-detail-container">
            <div className="cd-left">
              <div className="category-nav-dropdown">
                <div className="category-nav-header" onClick={toggleDropdown}>
                  <div>{activeTab || "Select Category"}</div>{" "}
                  <div>
                    <DownArrow />
                  </div>
                </div>

                {catergoryNavOpen && (
                  <ul ref={listRef}>
                    {categoriesList?.map((item, index) => {
                      // Check if the item's name is 'Services'
                      if (item?.name === "Services") {
                        // Skip rendering for 'Services'
                        return null;
                      }

                      return (
                        <li
                          key={index}
                          className={`${activeTab === item?.name ? "active" : ""
                            }`}
                          onClick={() => handleTabClick(item)}
                        >
                          {item?.name}
                        </li>
                      );
                    })}
                  </ul>
                )}
              
              </div>
              {categoriesList?.map((item, index) => {
                // Check if the item's name is 'Services'
                if (item?.name === "Services") {
                  // Skip rendering for 'Services'
                  return null;
                }

                return (
                  <div
                    key={index}
                    className={`cd-tab ${activeTab === item?.name ? "active" : ""
                      }`}
                    onClick={() => handleTabClick(item)}
                  >
                    {/* <div className="c-title">{item?.name}</div> */}
                    <div className="c-icon-wrap">
                      <div className="c-icon">
                        <img src={item?.image} alt={item?.name} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="cd-right">
              <>
                <div className="cd-heading">
                  <div className="cd-category-title">{activeTab}</div>
                  <div className="filter-wrap">
                    <Dropdown
                      show={isDropdownOpen}
                      onToggle={(isOpen) => setIsDropdownOpen(isOpen)}
                    >
                      <Dropdown.Toggle id="dropdown-basic">
                        <span>Filter</span>{" "}
                        <i>
                          <FilterIcon />
                        </i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <div className="filter-form">
                          <Form>
                            <Row className="g-2 flex-column">
                              <Col>
                                <Form.Label>Category</Form.Label>
                                <Form.Select
                                  value={selectCategory}
                                  onChange={handleCategory}
                                  aria-label="Default select example"
                                >
                                  <option>Select Category</option>
                                  {service.map((service) => (
                                    <option
                                      key={service._id}
                                      value={service._id}
                                    >
                                      {service.name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col>
                              {showSubCategory ? (
                                <Col>
                                  <Form.Label>Subcategory</Form.Label>
                                  <Form.Select
                                    value={selectService}
                                    onChange={handleSeviceChange}
                                    aria-label="Default select example"
                                  >
                                    <option>Select Subcategory</option>
                                    {subCategory.map((subCategory) => (
                                      <option
                                        key={subCategory._id}
                                        value={subCategory._id}
                                      >
                                        {subCategory.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </Col>
                              ) : null}
                              <Col>
                                <Form.Label>Rating</Form.Label>
                                <Form.Select
                                  value={selectRating}
                                  onChange={handleRateChange}
                                  aria-label="Default select example"
                                >
                                  <option key=" ">Select Rating</option>
                                  {ratings.map((ratings) => (
                                    <option
                                      key={ratings.value}
                                      value={ratings.value}
                                    >
                                      {ratings.label}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col>
                              <Col>
                                <Form.Label>Sort By</Form.Label>
                                <Form.Select
                                  aria-label="Default select example"
                                  value={selectSortBy}
                                  onChange={handleSortBy}
                                >
                                  <option value=" ">Select Sort By</option>
                                  {sortBy.map((sortBy) => (
                                    <option
                                      key={sortBy.value}
                                      value={JSON.stringify(sortBy.value)}
                                    >
                                      {sortBy.label}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col>
                              <Col>
                                <Form.Label>Price</Form.Label>
                                <RangeSlider
                                  min={min}
                                  max={max}
                                  allowCross={false}
                                  value={rangeValues}
                                  defaultValue={rangeValues}
                                  tipFormatter={(value) => `$${value}`}
                                  onChange={handleSliderChange}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3 g-2">
                              <Col sm={6}>
                                <div className="d-grid">
                                  {" "}
                                  <Button
                                    variant="outline-primary"
                                    onClick={clearFilter}
                                  >
                                    Clear Filter
                                  </Button>
                                </div>
                              </Col>
                              <Col sm={6}>
                                <div className="d-grid">
                                  {" "}
                                  <Button
                                    variant="primary"
                                    onClick={filterData1}
                                  >
                                    Apply Filter
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </Form>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                <div className="cd-list-wrap">
  {Array.isArray(providerData) && providerData.length > 0 ? (
    // Sort providerData by userRating in descending order
    providerData
      .slice() // Create a copy to avoid mutating the original array
      .sort((a, b) => (b.userRating || 0) - (a.userRating || 0)) // Handle cases where userRating might be undefined
      .map((provider) => (
        <div className="cd-listing" key={provider?._id}>
          <div className="c-img-wrap">
            <Swiper
              spaceBetween={0}
              slidesPerView={1}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
            >
              {provider?.images?.length > 0 ? (
                provider?.images?.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img src={image} alt="" />
                  </SwiperSlide>
                ))
              ) : (
                <SwiperSlide>
                  <img src={CategoryImg} alt="" />
                </SwiperSlide>
              )}
            </Swiper>

            <div className="c-img-title">{provider?.serviceId?.name}</div>
            {provider?.userId?.marketingEmail == null ? null : (
              <div className="c-img-type">
                <img src={FreeProvider} alt="provider type" />
              </div>
            )}
          </div>
          <div className="cd-listing-info">
            <div className="cd-user-detail-wrapper">
              <div className="cd-user-detail">
                <div className="cd-user-name-wrap">
                  {getFullName(
                    provider?.userId?.firstName,
                    provider?.userId?.lastName
                  )}
                </div>

                <div className="cd-rating-wrap">
                  <div className="cd-rating">
                    <StarRating size={22} rating={provider?.userRating || 0} />
                  </div>
                  <div className="cd-rating-value">
                    ({provider?.userRating || 0})
                  </div>
                </div>

                <div className="cd-user-name-wrap">
                  {provider?.userId?.badges?.map((item, index) => {
                    const badgeKey = getBadgeInfo(item);
                    const avatarSrc = avatarSources[badgeKey];
                    return (
                      <span
                        key={index}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "10px",
                        }}
                      >
                        {avatarSrc ? (
                          <div className="badge-content">
                            <img
                              src={avatarSrc}
                              alt={badgeKey}
                              style={{
                                width: "20px",
                                height: "20px",
                                marginRight: "5px",
                              }}
                            />
                            <span style={{ fontSize: "14px" }}>{badgeKey}</span>
                          </div>
                        ) : (
                          <span style={{ fontSize: "14px" }}>{item}</span>
                        )}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="cd-location">
              <div className="cd-location-icon">
                <LocationIcon />
              </div>
              <div className="cd-location-name">
                {provider?.userId?.location}
              </div>
            </div>
            <div>{provider?.userId?.bio}</div>

            <div className="cd-btn-wrap">
              <Button variant="outline-primary">${provider?.rate}</Button>
            </div>
            <div className="cd-btn-wrap">
              <Button
                variant="outline-primary"
                onClick={() => goToProviderProfile(provider)}
              >
                Hire Me
              </Button>
            </div>
          </div>
        </div>
      ))
  ) : (
    <NoRecordsProvider height="400px" />
  )}
</div>
              </>
            </div>
          </div>
        </div>
      </div>
      {filterA ? (
        providerData?.length > 0 ? (
          <Paginate
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={filterData2}
          />
        ) : null
      ) : (
        providerData?.length > 0 ? (
          <Paginate
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={getProvidrData}
          />
        ) : null
      )}

      <Footer />
    </>
  );
};

export default CategoryDetails;